
// import Lab from "../../views/lab/Lab";
import DashboardPage from "../../pages/dashboard/pages/DashboardPage";
import LayoutManager from "../../layout/LayoutManager";
import ProfilePage from "../../pages/profile/pages/ProfilePage";
import EcommercePage from "../../pages/ecommerce/pages/EcommercePage";

export const RoutesPrivates = [

  // PRIVADAS

  // {
  //   path: "/",
  //   exact: true,
  //   label: 'Lab',
  //   main: () => <LayoutManager children={ Lab } pageName={'Lab'} hideTheFooter={true}/>
  // },
  {
    path: "/",
    exact: true,
    label: 'DashboardPage',
    main: () => <LayoutManager children={ DashboardPage } pageName={'DashboardPage'} hideTheFooter={true}/>
  },
  {
    path: "/profile",
    exact: true,
    label: 'ProfilePage',
    main: () => <LayoutManager children={ ProfilePage } pageName={'ProfilePage'} hideTheFooter={true}/>
  },
  {
    path: "/ecommerce",
    exact: true,
    label: 'EcommercePage',
    main: () => <LayoutManager children={ EcommercePage } pageName={'EcommercePage'} hideTheFooter={true}/>
  },
  
];